<template>
  <div ref="roomsContainer" class="rooms">
    <div v-if="getRoomsDatas === null">Aucune salle existante</div>
    <div class="rooms-editing">
      <div>
        <el-slider v-if="zoomSliderIsVisible" v-model="scaleStage" @change="setSliderScale" vertical
          height="100px"></el-slider>
      </div>
    </div>
    <div class="black-inputs rooms-editing-center" v-if="!viewIsCentered">
      <el-button @click="centerRoom" class="dark" type="primary">Recentrer</el-button>
    </div>
    <v-stage ref="stage" :config="configKonva" v-if="getRoomsDatas !== null" @contentClick="handleStageClick">
      <v-layer>
        <v-rect ref="bckg" :config="configBackground" @click="unselect" @tap="unselect" @dragend="dragEndRoom"></v-rect>
      </v-layer>
      <v-layer ref="mainLayer" :config="configMainLayer">
        <v-group ref="zoneEditable">
          <v-rect :config="configZoneEditable"></v-rect>
          <v-image v-if="getStyleEdition" :config='configGridPoint'></v-image>
        </v-group>
        <v-group ref="linkedGroup">
          <Link v-for="link in getLinkedTables" :key="link.id" :tables="link" />
        </v-group>
        <v-group ref="baseGroup">
          <Table v-for="table in tables" :key="table.id" :table="table" :stage="$refs['stage']"
            :limits="$refs['zoneEditable']" :mainLayer="$refs['mainLayer']"></Table>
        </v-group>
        <v-group ref="dragGroup" :config="configDragLayer" v-if="getRoomsDatas !== null">
          <Table v-for="table in tablesDragging" :key="table.id" :table="table" :stage="$refs['stage']"
            :limits="$refs['zoneEditable']" :mainLayer="$refs['mainLayer']"></Table>
        </v-group>
      </v-layer>
    </v-stage>
    <div v-if="getRoomIsLock && !getModEdition" class="rooms-lock"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Link from './Link'
import Table from './Table'

export default {
  name: 'SingleRoom',
  components: {
    Table,
    Link
  },
  data() {
    return {
      gridImg: new Image(50, 50),
      configDragLayer: {
        listening: true,
        perfectDrawEnabled: false
      },
      configTextEmpty: {
        text: 'Aucune salle existante',
        fontFamily: 'Comfortaa',
        name: 'textEmpty',
        y: 20,
        x: 20,
        width: 200,
        fontStyle: 'bold',
        align: 'center',
        fill: '#DAE0F8'
      },
      lastDist: 0,
      lastPos: { x: 0, y: 0 },
      scaleStage: 100,
      scaleKStage: 1,
      viewIsCentered: true,
      init: true,
      mainLayerSize: null,
      hCanvas: 100,
      wCanvas: 100,
      maxScale: 1,
      minScale: 0.6
    }
  },
  computed: {
    ...mapGetters({
      getRoomsDatas: 'newRooms/getRoomsDatas',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getTables: 'newRooms/getTables',
      getSelectedTables: 'newRooms/getSelectedTables',
      getUnitGrid: 'newRooms/getUnitGrid',
      getUnitTable: 'newRooms/getUnitTable',
      getModEdition: 'newRooms/getModEdition',
      getStyleEdition: 'newRooms/getStyleEdition',
      getModLinkTable: 'newRooms/getModLinkTable',
      getTableIsLoaded: 'newRooms/getTableIsLoaded',
      getLinkedTables: 'newRooms/getLinkedTables',
      getDisplayTableById: 'newRooms/getDisplayTableById',
      getSelectedRoomName: 'newRooms/getSelectedRoomName',
      getRoomIsLocked: 'newRooms/getRoomIsLocked',
      getDateToTimestamp: 'calendar/getDateToTimestamp',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getSelectedDay: 'calendar/getSelectedDay',
      isVisiblePopupManageServices: 'displayer/isVisiblePopupManageServices',
      getModSwitchTable: 'newReservations/getModSwitchTable',
      getResaToSwitch1: 'newReservations/getResaToSwitch1',
      getResaToSwitch2: 'newReservations/getResaToSwitch2'
    }),
    getRoomIsLock: function () {
      return this.getRoomIsLocked({
        ts: parseInt(this.getDateToTimestamp(this.getSelectedDay)),
        room: this.getSelectedRoom,
        service: this.getSelectedMainService
      })
    },
    zoomSliderIsVisible: function () {
      return this.minScale !== this.maxScale
    },
    configKonva: function () {
      return {
        width: this.wCanvas,
        height: this.hCanvas
      }
    },
    configGridPoint: function () {
      return {
        x: this.configZoneEditable.x + this.getUnitGrid,
        y: this.configZoneEditable.y + this.getUnitGrid,
        fill: this.configZoneEditable.fill,
        fillPatternImage: this.gridImg,
        width: this.configZoneEditable.width - this.getUnitGrid,
        height: this.configZoneEditable.height - this.getUnitGrid,
        fillPatternRepeat: 'repeat',
        listening: false,
        perfectDrawEnabled: false
      }
    },
    configMainLayer: function () {
      return {
        draggable: false,
        perfectDrawEnabled: false
      }
    },
    configZoneEditable: function () {
      let docStyle = getComputedStyle(document.documentElement)
      let fillColor = docStyle.getPropertyValue('--dark__main_color')
      let strokeColor = docStyle.getPropertyValue('--dark__main_color')
      if (this.getStyleEdition) {
        fillColor = ''
        strokeColor = '#8e8e8e'
      }
      return {
        y: 0,
        x: 0,
        width: 800,
        height: 800,
        stroke: strokeColor,
        fill: fillColor,
        strokeWidth: 2,
        listening: false
      }
    },
    centeredPosLimits: function () {
      return {
        x: ((this.wCanvas / this.scaleKStage) - 800) / 2,
        y: ((this.hCanvas / this.scaleKStage) - 800) / 2
      }
    },
    configBackground: function () {
      return {
        name: 'textEmpty',
        y: 0,
        x: 0,
        width: 2000,
        height: 2000,
        draggable: true,
        dragBoundFunc: (pos) => {
          // vars
          let kRoom = this.$refs['mainLayer'].getStage()
          let kStage = this.$refs['stage'].getStage()

          let dragX = this.lastPos.x - pos.x
          let dragY = this.lastPos.y - pos.y
          let posX = kRoom.position().x - dragX
          let posY = kRoom.position().y - dragY

          let canMoveX = true
          let canMoveY = true

          // limit zone editable
          let limitRect = this.$refs['zoneEditable'].getStage().getClientRect()
          let scale = kStage.scaleX()

          // init lastPos if is null
          if (this.lastPos.x === 0 && this.lastPos.y === 0) {
            this.lastPos = pos
          }

          // restriction for modEdition off
          let wCan = this.wCanvas - (this.getUnitTable * 2)
          let hCan = this.hCanvas - (this.getUnitTable * 2)
          if (!this.getModEdition) {
            let roomRect = this.getRectTablesBoudingBox()
            if (roomRect.width * scale < wCan) canMoveX = false
            if (roomRect.height * scale < hCan) canMoveY = false
          }

          if (canMoveX) {
            if (limitRect.width * scale < wCan) {
              posX = this.centeredPosLimits.x
            } else {
              let max = (limitRect.width) - this.wCanvas
              posX = Math.max((max + this.getUnitTable) * -1, Math.min(this.getUnitTable, posX))
            }
            kRoom.x(posX)
          }

          if (canMoveY) {
            if (limitRect.height * scale < hCan) {
              posY = this.centeredPosLimits.y
            } else {
              let max = (limitRect.height) - this.hCanvas
              posY = Math.max((max + this.getUnitTable) * -1, Math.min(this.getUnitTable, posY))
            }
            kRoom.y(posY)
          }

          kStage.getStage().batchDraw()
          // store last pos
          this.lastPos = pos
          // return zero just for get drag movements
          return {
            x: 0,
            y: 0
          }
        }
      }
    },
    /** getTables tables didn't dragged **/
    tables: function () {
      if (this.getRoomsDatas !== null) {
        let tables = []
        if (this.getTables !== null && this.getTables !== undefined) {
          Object.entries(this.getTables).forEach(([tid, table]) => {
            if (table.isDragging === false) {
              tables.push(table)
            }
          })
        }
        return tables
      }
    },
    /** getTablesDragging tables currently dragged **/
    tablesDragging: function () {
      if (this.getRoomsDatas !== null && this.getModEdition) {
        let tables = []
        if (this.getTables !== null && this.getTables !== undefined) {
          Object.entries(this.getTables).forEach(([tid, table]) => {
            if (table.isDragging === true) {
              tables.push(table)
            }
          })
        }
        return tables
      }
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize(null)
    this.gridImg.src = '/img/asset-grid-point.png';

    if (this.getModSwitchTable) {
      if (this.getResaToSwitch1.data !== undefined) {
        this.selectTableToSwitch()
      }
    }
  },
  updated: function () {
    // check all tables is loaded and centerRoom at launch
    if (this.$refs['mainLayer'] !== undefined &&
      this.$refs['mainLayer'].getStage().getClientRect().width > 0 &&
      (this.mainLayerSize === null || this.$refs['mainLayer'].getStage().getClientRect().width !== this.mainLayerSize.width) &&
      this.init && this.getTableIsLoaded) {
      this.init = false
      this.centerRoom()
      this.setRightSideLoading(false)
    }
  },
  watch: {
    /** Listener on room change / select **/
    'getSelectedRoom': function (val, oldVal) {
      if (val === '' || val !== oldVal) {
        this.init = true
      }
    },
    'getSelectedTables': function (val, oldVal) {
      if (val.length > 0 && !this.getModEdition) {
        if (!this.isVisiblePopupManageServices) this.setPopupTableSelected(true)
      } else if (this.getModSwitchTable) {
        console.log('TODO Hide table popup')
      } else {
        this.setPopupTableSelected(false)
      }
    },
    'getModEdition': function (val, oldVal) {
      if (oldVal && !val) this.centerRoom()
    },
    'getSelectedRoomName': function (val, oldVal) {
      if (oldVal && !val) setTimeout(() => this.centerRoom(), 500)
    }
  },
  methods: {
    ...mapMutations({
      setModAddTable: 'newRooms/setModAddTable',
      setWidthAndHeight: 'newRooms/setWidthAndHeight',
      setTableIsDraggable: 'newRooms/setTableIsDraggable',
      setSelectedRoom: 'newRooms/setSelectedRoom',
      setPopupTableSelected: 'displayer/setPopupTableSelected',
      setRightSideLoading: 'displayer/setRightSideLoading',
      setResaToSwitch1: 'newReservations/setResaToSwitch1',
      setResaToSwitch2: 'newReservations/setResaToSwitch2'
    }),
    ...mapActions({
      removeTable: 'newRooms/removeTable',
      unSelectedTables: 'newRooms/unSelectedTables',
      saveRoom: 'newRooms/saveRoom',
      selectTableToSwitch: 'newReservations/selectTableToSwitch'
    }),
    handleResize: function (event) {
      if (this.getRoomsDatas !== null) {
        // vars
        let roomContainer = this.$refs['roomsContainer']
        let kStage = this.$refs['stage'].getStage()
        // set width, height, scale, pos
        this.wCanvas = roomContainer.clientWidth
        this.hCanvas = roomContainer.clientHeight
        this.setWidthAndHeight({ width: this.wCanvas, height: this.hCanvas })
        kStage.width(this.wCanvas)
        kStage.height(this.hCanvas)
        kStage.scale({ x: 1, y: 1 })
        kStage.getStage().offset({
          x: 0,
          y: 0
        })
        kStage.getStage().position({ x: 0, y: 0 })
        kStage.getStage().setAbsolutePosition({ x: 0, y: 0 })
        this.configBackground.width = this.wCanvas
        this.configBackground.height = this.hCanvas
        // recenter
        this.centerRoom()
        // set event listener for scale
        kStage.getContent().removeEventListener('touchmove', this.tuchMov)
        kStage.getContent().removeEventListener('touchend', this.tuchEnd)
        kStage.getContent().addEventListener('touchmove', this.tuchMov, false)
        kStage.getContent().addEventListener('touchend', this.tuchEnd, false)
        // redraw stage
        kStage.batchDraw()
        // hack for font
        setTimeout(() => {
          kStage.batchDraw()
        }, 500)
      }
    },
    dragEndRoom: function () {
      this.viewIsCentered = this.checkIsCenteredView()
      this.lastPos = { x: 0, y: 0 }
    },
    handleStageClick() {
      const stage = this.$refs.stage.getStage()
      const pointer = stage.getPointerPosition()
      const shape = stage.getIntersection(pointer)

      const isBackground = !shape || shape.name() === 'textEmpty'

      if (isBackground) this.unSelectRoom()
    },
    unSelectRoom: function () {
      this.unSelectedTables()
      if (!this.getModEdition) {
        this.setSelectedRoom('')
        this.setPopupTableSelected(false)
      }
    },
    unselect: function () {
      this.unSelectedTables()
      if (this.getModSwitchTable) {
        this.setResaToSwitch1({})
        this.setResaToSwitch2({})
      }
    },
    tuchMov: function (e) {
      let touch1 = e.touches[0]
      let touch2 = e.touches[1]
      if (touch1 && touch2) {
        // vars
        let kStage = this.$refs['stage'].getStage()
        let dist = getDistance({
          x: touch1.clientX,
          y: touch1.clientY
        }, {
          x: touch2.clientX,
          y: touch2.clientY
        })

        this.setTableIsDraggable(false)

        if (!this.lastDist || this.lastDist === 0) {
          this.lastDist = dist
        } else {
          // calc the authorized scale
          let scale = this.limitScale(kStage.scaleX() * dist / this.lastDist)
          // set scale to stage
          kStage.scaleX(scale)
          kStage.scaleY(scale)
          // set scale to slider
          this.scaleStage = this.scaleInPercent(scale)
          this.scaleKStage = scale
          this.centerRoom(false)
          // redraw stage
          kStage.batchDraw()
          // store last dist
          this.lastDist = dist
        }
      }
    },
    tuchEnd: function (vueComponent, e) {
      this.lastDist = 0
      this.setTableIsDraggable(true)
    },
    scaleInPercent: function (s) {
      let step = this.maxScale - this.minScale
      let sInStep = s - this.minScale
      return (sInStep / step) * 100
    },
    limitScale: function (val) {
      if (val > this.maxScale) return this.maxScale
      if (val < this.minScale) return this.minScale
      return val
    },
    setSliderScale: function (evt) {
      // vars
      let sInStep = ((evt / 100) * (this.maxScale - this.minScale)) + this.minScale
      let kStage = this.$refs['stage'].getStage()
      // set scale
      kStage.scaleX(sInStep)
      kStage.scaleY(sInStep)
      this.scaleKStage = sInStep
      this.centerRoom(false)
      // redraw stage
      kStage.batchDraw()
    },
    centerRoomWithLimits: function () {
      let kRoom = this.$refs['mainLayer'].getStage()
      kRoom.x(this.centeredPosLimits.x)
      kRoom.y(this.centeredPosLimits.y)
    },
    centerRoom: function (scaleAuto = true) {
      // center tables bouding box
      let kStage = this.$refs['stage'].getStage()
      let kRoom = this.$refs['mainLayer'].getStage()
      let kBckg = this.$refs['bckg'].getStage()

      if (this.tables.length > 0 && !this.getModEdition) {
        // reinit scale and positions
        let rectML = this.getRectTablesBoudingBox()
        if (scaleAuto) {
          kStage.scale({ x: 1, y: 1 })
          this.fitRoomToViewPortScale(rectML)
        }
        // set pos to center
        let scale = this.scaleKStage
        let realXPosRoom = kRoom.x() + rectML.x + (rectML.width / 2)
        let difX = ((this.wCanvas / scale) / 2) - realXPosRoom
        kRoom.x(kRoom.x() + difX)
        let realYPosRoom = kRoom.y() + rectML.y + (rectML.height / 2)
        let difY = ((this.hCanvas / scale) / 2) - realYPosRoom
        kRoom.y(kRoom.y() + difY)
      } else {
        if (scaleAuto) {
          this.fitRoomToViewPortScale(this.getGridRect())
        }
        this.centerRoomWithLimits()
      }

      // reinit room dragger
      kBckg.setAbsolutePosition({ x: 0, y: 0 })
      // redraw stage
      kStage.batchDraw()
      this.mainLayerSize = kRoom.getClientRect()
      // check if view is centered
      this.viewIsCentered = this.checkIsCenteredView()
    },
    getGridRect: function () {
      return {
        width: 800,
        height: 800,
        x: this.$refs['zoneEditable'].getStage().getClientRect().x,
        y: this.$refs['zoneEditable'].getStage().getClientRect().y
      }
    },
    getRectTablesBoudingBox: function () {
      if (this.tables.length > 0) {
        let minX = this.tables[0].x - ((this.tables[0].width / 2) * this.getUnitTable)
        let minY = this.tables[0].y - ((this.tables[0].height / 2) * this.getUnitTable)
        let maxX = this.tables[0].x + ((this.tables[0].width / 2) * this.getUnitTable)
        let maxY = this.tables[0].y + ((this.tables[0].height / 2) * this.getUnitTable)
        this.tables.forEach((table) => {
          let testVal = table.x - ((table.width / 2) * this.getUnitTable)
          if (testVal < minX) minX = testVal

          testVal = table.y - ((table.height / 2) * this.getUnitTable)
          if (testVal < minY) minY = testVal

          testVal = table.x + ((table.width / 2) * this.getUnitTable)
          if (testVal > maxX) maxX = testVal

          testVal = table.y + ((table.height / 2) * this.getUnitTable)
          if (testVal > maxY) maxY = testVal
        })
        return {
          width: maxX - minX,
          height: maxY - minY,
          x: minX,
          y: minY
        }
      } else {
        return {
          width: 0,
          height: 0,
          x: 0,
          y: 0
        }
      }
    },
    checkIsCenteredView: function () {
      // vars
      let kRoom = this.$refs['mainLayer'].getStage()
      let rectRoom = this.getRectTablesBoudingBox()
      let scale = this.scaleKStage
      if (this.getModEdition) {
        rectRoom = this.getGridRect()
        if (this.$refs['mainLayer'] !== undefined &&
          rectRoom.width * scale <= this.wCanvas &&
          rectRoom.height * scale <= this.hCanvas &&
          kRoom.x() === this.centeredPosLimits.x &&
          kRoom.y() === this.centeredPosLimits.y &&
          Math.round(this.getFitRoomScaleFact(rectRoom) * 100) === Math.round(scale * 100)) return true
      } else {
        let realXPosRoom = kRoom.x() + rectRoom.x + (rectRoom.width / 2)
        let difX = ((this.wCanvas / scale) / 2) - realXPosRoom
        let realYPosRoom = kRoom.y() + rectRoom.y + (rectRoom.height / 2)
        let difY = ((this.hCanvas / scale) / 2) - realYPosRoom
        if (this.$refs['mainLayer'] !== undefined &&
          rectRoom.width * scale <= this.wCanvas &&
          rectRoom.height * scale <= this.hCanvas &&
          Math.round(kRoom.x() * 100) === Math.round((kRoom.x() + difX) * 100) &&
          Math.round(kRoom.y() * 100) === Math.round((kRoom.y() + difY) * 100) &&
          Math.round(this.getFitRoomScaleFact(rectRoom) * 100) === Math.round(scale * 100)) return true
      }
      // check if position is zero and width & height is in the canvas
      return false
    },
    fitRoomToViewPortScale: function (rectML) {
      // get new scale
      let scale = this.getFitRoomScaleFact(rectML)
      this.$refs['stage'].getStage().scale({ x: scale, y: scale })
      // limit scale if not in mod edition
      if (!this.getModEdition) this.minScale = scale
      else this.minScale = 0.6
      this.scaleStage = this.scaleInPercent(scale)
      this.scaleKStage = scale
    },
    getFitRoomScaleFact: function (rectML) {
      let scale = 1
      // add Unit Table for fit with a padding of untitable / 2
      let widthML = rectML.width + this.getUnitTable
      let heightML = rectML.height + this.getUnitTable
      if (widthML !== 0 && (this.wCanvas < widthML || this.hCanvas < heightML)) {
        scale = this.wCanvas / widthML
        if (heightML * scale > this.hCanvas) scale = this.hCanvas / heightML
        scale = this.limitScale(scale)
      }
      return scale
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}

function getDistance(p1, p2) {
  return Math.sqrt(Math.pow((p2.x - p1.x), 2) + Math.pow((p2.y - p1.y), 2))
}
</script>

<style lang="scss"></style>
